import { GlobalSearchTypeEnum } from '../enums';

export const SearchTypeLabels = {
  [GlobalSearchTypeEnum.Opportunities]: 'shared.features.globalSearch.opportunities',
  [GlobalSearchTypeEnum.Campaigns]: 'shared.features.globalSearch.campaigns',
  [GlobalSearchTypeEnum.Accounts]: 'shared.features.globalSearch.accounts',
  [GlobalSearchTypeEnum.Channels]: 'shared.features.globalSearch.channels',
}
